<template>
  <a-modal
    v-bind="$attrs"
    v-on="$listeners"
    :visible="visible"
    @cancel="handleCancel"
  >
    <template slot="footer">
      <a-button key="cancel" :loading="loading" @click="handleCancel">
        取消
      </a-button>
      <a-button key="submit" type="primary" :loading="loading" @click="handleOk">
        确定
      </a-button>
    </template>
    <a-form v-bind="formItemLayout" :form="modifyForm" @submit="handleOk">
      <a-form-item label="渠道子账户账号">
        <a-input
          placeholder="请输入渠道子账户账号"
          class="modal-form"
          v-decorator="
           ['channelSubAcctNo', { rules: [{ required: true, type: 'string', message: '渠道子账户账号不能为空' }] }]"
        ></a-input>
      </a-form-item>
      <a-form-item label="渠道子账户名称">
        <a-input
          placeholder="请输入渠道子账户名称"
          class="modal-form"
          v-decorator="
           ['channelSubAcctName', { rules: [{ required: true, type: 'string', message: '渠道子账户名称不能为空' }] }]"
        ></a-input>
      </a-form-item>
      <a-form-item label="渠道子账户类型">
        <a-select
          class="modal-form"
          placeholder="请选择渠道子账户类型"
          showSearch
          optionFilterProp="label"
          v-decorator="
           ['channelSubAcctType', { rules: [{ required: true, validateTrigger: 'change', type: 'string', message: '渠道子账户类型不能为空' }] }]"
        >
          <a-select-option v-for="(it, id) in subAccountType" :key="id" :value="it.code" :label="it.name">
            {{it.name}}
          </a-select-option>
        </a-select>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
// import { formItemLayout } from '@/config'

export default {
  name: 'CreateChannelSubAccount',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    visible: false,
    loading: false,
    formItemLayout: Object.freeze({
      labelCol: {
        span: 7
      },
      wrapperCol: {
        span: 17
      }
    }),
    subAccountType: Object.freeze([
      {
        code: '01',
        name: 'DVA子账户'
      },
      {
        code: '02',
        name: 'SVA子账户'
      }
    ])
  }),
  created () {
    this.modifyForm = this.$form.createForm(this, { name: 'modifyForm' })
  },
  methods: {
    handleCancel () {
      this.visible = false
      this.modifyForm.resetFields()
    },
    handleOk () {
      this.modifyForm.validateFields(async (err, values) => {
        if (!err) {
          const params = {
            ...values,
            channelAcctId: this.item.id
          }
          this.loading = true
          const { succ } = await this.$http.channel.channelSubAcctAdd(params)
          this.loading = false
          if (succ) {
            this.$message.success('新增成功！')
            this.handleCancel()
            this.$emit('success')
          }
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
@import "~@/components/modal-form.less";
</style>
